import { Reveal, SectionHead } from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { SAT2FARM_BENEFITS, POSTERS, CONTACT } from "@/data/site";

export const Sat2Farm = ({ onPoster }) => (
  <section id="sat2farm" className="relative py-32 sm:py-40" data-testid="sat2farm-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="03 — In Partnership With Sat2Farm"
        title="Precision agriculture, delivered by satellite."
        sub="Through this partnership, KMG Digi Platform now offers advanced satellite-based farm management solutions from Sat2Farm — giving farmers real-time insights, smarter decisions and higher productivity."
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-20">
        <Reveal className="lg:col-span-7">
          <div className="border border-[rgba(111,227,155,0.18)] bg-[color:var(--kmg-emerald)] p-9">
            <h3 className="font-display text-xl">What is Sat2Farm?</h3>
            <p className="text-base mt-5 text-[color:var(--kmg-bone-dim)] leading-relaxed">
              Sat2Farm uses satellite imagery and advanced analytics to provide accurate, actionable
              insights about your crops, soil and land — helping you farm smarter, reduce risk and
              increase yields.
            </p>
            <div className="mt-9 pt-8 border-t border-[rgba(244,241,230,0.14)]">
              <h3 className="font-display text-xl">Where is Sat2Farm based?</h3>
              <p className="text-base mt-5 text-[color:var(--kmg-bone-dim)] leading-relaxed">
                Sat2Farm is a South African agri-tech company headquartered in Cape Town, Western Cape,
                with a local team supporting farmers across South Africa and the African continent.
              </p>
              <address className="not-italic font-mono-label text-[11px] leading-relaxed mt-6 text-[color:var(--kmg-lime)]" data-testid="sat2farm-address">
                {CONTACT.sat2farm.map((l) => (
                  <span key={l} className="block">{l}</span>
                ))}
              </address>
            </div>
            <p className="font-editorial italic text-2xl mt-10">Better insights. Bigger harvests.</p>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-5">
          <button
            onClick={() => onPoster(POSTERS.sat2farm)}
            data-testid="sat2farm-poster-btn"
            className="block w-full border border-[rgba(111,227,155,0.2)] overflow-hidden"
          >
            <img src={POSTERS.sat2farm} alt="KMG Digi and Sat2Farm partnership" className="w-full h-auto" />
          </button>
        </Reveal>
      </div>

      <div className="mt-24">
        <Reveal>
          <p className="eyebrow">Key benefits for KMG Digi Platform farmers</p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-9 mt-12">
          {SAT2FARM_BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.04}>
              <div className="flex gap-4" data-testid={`sat2farm-benefit-${i}`}>
                <span className="grid place-items-center w-11 h-11 rounded-full bg-[color:var(--kmg-emerald)] border border-[rgba(111,227,155,0.25)] shrink-0">
                  <Icon name={b.icon} size={17} className="text-[color:var(--kmg-lime)]" />
                </span>
                <div>
                  <h4 className="font-display text-base leading-snug">{b.title}</h4>
                  <p className="text-sm mt-1.5 text-[color:var(--kmg-bone-dim)] leading-relaxed">{b.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
